<template>
  <div class="content">
    <!-- Move to wallet modal  -->
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Move to Wallet</md-dialog-title>
      <md-dialog-content>Are you sure?</md-dialog-content>
      <md-dialog-actions>
        <md-button
          class="md-success"
          @click="
            showDialog = false
            moveCommissionToWallet()
          "
          >YES</md-button
        >
        <md-button class="md-danger" @click="showDialog = false">NO</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- Move to wallet   -->
    <div class="md-layout cards">
      <!-- Wallet Score Card -->
      <div
        class="md-layout-item md-medium-size-50 md-small-size-100 md-size-50"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>assessment</md-icon>
          </template>

          <template slot="content">
            <p class="category">Wallet Balance</p>
            <h3 class="title">
              {{ formatAmount(walletData.balance) || formatAmount(0) }}
            </h3>
          </template>

          <!-- <template slot="footer" v-if="checkPermission('wallet', 'fundWallet')"> -->
          <template slot="footer" >
            <div class="stats">
              <md-icon>add</md-icon>
              <a href="#" @click.prevent="openFundWalletModal()">Fund Wallet</a>
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-small-size-100 md-size-50"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>assessment</md-icon>
          </template>

          <template slot="content">
            <p class="category">Commission Balance</p>
            <h3 class="title">
              {{
                formatAmount(walletData.commission) || formatAmount(0)
              }}
            </h3>
          </template>

          <!-- <template slot="footer" v-if="checkPermission('wallet', 'export')"> -->
          <template slot="footer" >
            <div class="stats">
              <md-icon>local_offer</md-icon>

              <a href="#" @click="showDialog = true">Move to Wallet</a>
            </div>
          </template>
        </stats-card>
      </div>
    </div>

    <!-- Filter -->
   <FilterWallet
   @reset="resetQuery"
   @filter="filterTransactions"
   @filterDate="filterDate"
   @getDate="getDate"
   @dateFilter="editDateRange"
/>

    <!-- Table -->
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-content><div class="text-right">
            <div>
              <md-button class="md-raised md-primary" @click="exportToExcel()">
                <span v-if="isExportingData" class="spinner"></span>
                {{ isExportingData ? 'VIEW EXPORT PROGRESS' : 'EXPORT TO EXCEL' }}
              </md-button>
            </div>
          </div>
            <div>
              <div>
                <md-table table-header-color="green">
                  <md-table-row>
                    <md-table-head>S/N</md-table-head>
                    <md-table-head>Date</md-table-head>
                    <md-table-head>Reference</md-table-head>
                    <md-table-head>Amount (&#8358;)</md-table-head>
                    <md-table-head>Operation</md-table-head>
                    <md-table-head>Type</md-table-head>
                    <md-table-head>Balance Before</md-table-head>
                    <md-table-head>Balance After</md-table-head>
                  </md-table-row>

                  <md-table-row v-if="wallet.length < 1">
                    <md-table-cell colspan="9">
                      <p>No record found.</p>
                    </md-table-cell>
                  </md-table-row>

                  <md-table-row
                    v-for="(transaction, index) in this.wallet"
                    :key="index"
                  >
                    <md-table-cell md-label="S/N">
                      {{ index + 1 }}
                    </md-table-cell>
                    <md-table-cell md-label="Date">
                      {{ format(transaction.created_at, 'DD/MM/YYYY hh:mm a') }}
                    </md-table-cell>
                    <md-table-cell md-label="Reference">
                      {{ transaction.ref }}
                    </md-table-cell>
                    <md-table-cell md-label="Amount">
                      {{ formatAmount(transaction.amount) }}
                    </md-table-cell>
                    <md-table-cell md-label="Operation">
                      {{ transaction.operation ? transaction.operation : '' }}
                    </md-table-cell>

                    <md-table-cell md-label="Type">
                      {{
                        transaction.type ? transaction.type.toUpperCase() : ''
                      }}
                    </md-table-cell>

                    <md-table-cell md-label="Balance Before">
                      {{ formatAmount(transaction.balance_before) }}
                    </md-table-cell>
                    <md-table-cell md-label="Balance After">
                      {{ formatAmount(transaction.balance_after) }}
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <br />
                <div v-if="wallet.length > 28">
                  <md-button class="md-primary" @click="loadMore()"
                    >Load More</md-button
                  >
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <!-- Fund Wallet Modal -->
    <fund-wallet-modal ref="fundWalletModal" />

    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import format from 'date-fns/format';
import moment from 'moment';
import { StatsCard } from '../../components/index';
import { checkPermission } from '../../utils/Acl.util';
import { commaNumber, formatAmount } from '../../utils/Formatter.util';
import http from '../../utils/Http.util';
import FilterWallet from './FilterWallet.vue';
import FundWalletModal from './FundWalletModal.vue';

export default {
  components: {
    FundWalletModal,
    FilterWallet,
    StatsCard,
  },
  computed: {
    activeBusiness() {
      return this.$store.state.activeBusiness;
    },
    isLive() {
      return this.$store.state.isLive;
    },
  },
  mounted() {
    this.wallet = this.$store.state.walletLogs;
    this.getTransactions();
    this.getWalletBalance();
  },
  created() {
    this.userData = this.$store.state.userData;
    // this.setMerchantId(this.$store.state.selectedMerchant.id);
  },
  data() {
    return {
      showDatePicker: false,
      isExportingData: false,
      dateFilter: 'DAY',
      walletQuery: {
        offset: null,
        merchantId: '',
        page: 1,
        limit: 30,
        ref: '',
        checkpoint: null,
        filteredQuery: {},
        order: JSON.stringify([['created_at', 'DESC']]),
        start: null,
        end: null,
        get created_at() {
          return {
            $between: [this.start, this.end],
          };
        },
      },
      defaultWalletQuery: {
        offset: null,
        merchantId: '',
        page: 1,
        limit: 20,
        ref: '',
        checkpoint: null,
        filteredQuery: {},
        order: JSON.stringify([['created_at', 'DESC']]),
        start: null,
        end: null,
        get created_at() {
          return {
            $between: [this.start, this.end],
          };
        },
      },
      filterQuery: {},
      wallet: [],
      snackBar: {
        show: false,
        message: null,
      },
      userData: {},
      walletData: {
        balance: 0,
        commission: 0,
      },
      isSummaryLoading: false,
      summary: {
        vend: 0,
        commission: 0,
      },
      showDialog: false,
    };
  },

  methods: {
    commaNumber,
    format,
    formatAmount,
    checkPermission,
    editDateRange(view) {
      this.dateFilter = view;
    },
    setIsExportingData(val) {
      this.isExportingData = val;
    },
    getExportFileName() {
      const filename = `Wallet Export - ${format(Date.now(), 'DD/MM/YYYY hh:mm a')}`;
      return filename;
    },
    getDate(view) {
      let from = null;
      let to = null;

      switch (view) {
        case 'DAY':
          from = moment(from)
            .subtract(1, 'day')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'MONTH':
          from = moment(from)
            .subtract(1, 'month')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'YEAR':
          from = moment(from)
            .subtract(1, 'year')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        default:
          break;
      }
      return { from, to };
    },
    filterDate(view) {
      let from = new Date();
      let to = new Date();

      switch (view) {
        case 'DAY':
          from = moment(from)
            .subtract(1, 'day')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'MONTH':
          from = moment(from)
            .subtract(1, 'month')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'YEAR':
          from = moment(from)
            .subtract(1, 'year')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        default:
          from = null;
          to = null;
          this.showDatePicker = false;
          break;
      }

      this.walletQuery.start = from;
      this.walletQuery.end = to;
      this.filterTransactions(this.walletQuery);
    },

    // async getWalletTransactions() {
    //   this.$store.commit("busyStatus", true);
    //   try {
    //     const { created_at, order, ref } = this.walletQuery;
    //     let query = "";
    //     const jsonQuery = JSON.stringify(query);
    //     const { data } = await http.authReq(
    //       `/dashboard/wallet-transactions/?order=${order}`,
    //       {
    //         where: jsonQuery,
    //       }
    //     );
    //   } catch (error) {
    //     this.snackBar = {
    //       show: true,
    //       message: error.response ? error.response.data.message : error.message,
    //     };
    //   }
    //   this.$store.commit("busyStatus", false);
    // },
    setMerchantId(id) {
      this.walletQuery.merchantId = id;
      this.getTransactions();
    },
    async getTransactions() {
      this.$store.commit('busyStatus', true);
      try {
        // const { phone } = this.walletQuery;
        /* if there is a phone number and its not the number of the selected merchant in state,
           set the id to a falsy value, so we can query by phone number alone
        */
        // if (phone && phone !== this.$store.state.selectedMerchant.phone) {
        //   this.walletQuery.merchantId = "";
        // }
        this.$store.commit('setWalletQuery', this.walletQuery);
        const { data } = await http.authReq('/dashboard/wallet-transactions');
        this.walletQuery.start = moment(new Date())
          .subtract(1, 'day')
          .utc()
          .toDate();
        this.walletQuery.end = moment(new Date())
          .utc()
          .toDate();
        this.walletQuery.checkpoint = data.length > 0 ? data[0].created_at : null;
        this.wallet = data;
        this.$store.commit('setWalletLogs', data);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
      this.$store.commit('busyStatus', false);
    },
    async exportToExcel() {
      const startMoment = moment(this.walletQuery.start);

      const startDate = (this.dateFilter !== 'CUSTOM'
        ? startMoment
        : startMoment.startOf('day')
      ).format('YYYY-MM-DD HH:mm:ss');

      const endMoment = moment(this.walletQuery.end);

      const endDate = (this.dateFilter !== 'CUSTOM'
        ? endMoment
        : endMoment.endOf('day')
      ).format('YYYY-MM-DD HH:mm:ss');
      const params = new URLSearchParams({
        report_type: 'wallet',
        startDate,
        endDate,
      });
      try {
        const res = await http.authReq(`/dashboard/reports?${params.toString()}`, null, 'post');
        this.snackBar = {
          show: true,
          message: res.message,
        };
      } catch (err) {
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
      }
    },
    openFundWalletModal() {
      this.$refs.fundWalletModal.open();
    },
    async getWalletBalance() {
      try {
        const { data } = await http.authReq('/dashboard/wallet');
        this.walletData = data;
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
    },
    async moveCommissionToWallet() {
      try {
        this.$store.commit('busyStatus', true);
        const { message } = await http.authReq('/dashboard/commission/transfer');
        await this.getTransactions();
        await this.getWalletBalance();
        await this.$parent.getActiveBusiness();
        this.snackBar = {
          show: true,
          message,
        };
        this.$store.commit('busyStatus', false);
      } catch (error) {
        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
    },
    async loadMore() {
      this.$store.commit('busyStatus', true);
      const {
        limit,
        page,
        checkpoint,
        offset,
        order,
        filteredQuery,
      } = this.walletQuery;
      const nextPage = page + 1;
      try {
        const { data } = await http.authReq(
          `/dashboard/wallet-transactions?checkpoint=${checkpoint}&limit=${limit}&page=${nextPage}&offset=${offset}&order=${order}`,
          {
            where: filteredQuery,
          },
        );
        if (data.length <= 0) {
          this.snackBar = {
            show: true,
            message: 'Nothing more to load.',
          };
        } else {
          this.walletQuery.page = nextPage;
          this.wallet = [...this.wallet, ...data];
          this.$store.commit('setWalletLogs', [...this.wallet, ...data]);
        }
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
      this.$store.commit('busyStatus', false);
    },
    async filterTransactions(walletQuery) {
      this.$store.commit('busyStatus', true);
      try {
        const { created_at, order, ref } = walletQuery || this.walletQuery;
        const query = ref !== '' && created_at.$between[0]
          ? { created_at, ref }
          : ref !== ''
            ? { ref }
            : created_at.$between[0]
              ? { created_at }
              : {};

        const jsonQuery = JSON.stringify(query);
        const { data } = await http.authReq(
          `/dashboard/wallet-transactions/?order=${order}`,
          {
            where: jsonQuery,
          },
        );
        this.walletQuery.start = walletQuery.iso_start;
        this.walletQuery.end = walletQuery.iso_end;
        this.walletQuery.filteredQuery = jsonQuery;
        this.walletQuery.checkpoint = data.length > 0 ? data[0].created_at : null;
        this.wallet = data;
        this.$store.commit('setWalletLogs', data);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
      this.$store.commit('busyStatus', false);
    },
    async resetQuery() {
      await this.getTransactions();
      this.filterQuery = {};
      this.walletQuery = this.defaultWalletQuery;
      this.showDatePicker = false;
      const fields = document.querySelectorAll('.md-input');
      for (let key = 0; key < fields.length; key += 1) {
        fields[key].value = '';
      }
    },
    getSummary() {
      this.isSummaryLoading = true;

      http
        .authReq(
          `/dashboard/aggregation/summary?generated_by=${
            this.activeBusiness.id
          }`,
        )
        .then(({ data }) => {
          this.summary = data;
          this.isSummaryLoading = false;
        })
        .catch((err) => {
          this.snackBar = {
            show: true,
            message: err.response ? err.response.data.message : err.message,
          };
          this.isSummaryLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.page-btn {
  margin-right: 20px;
  font-size: 20px !important;
}

.spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 8px;
  vertical-align: middle;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
